// extracted by mini-css-extract-plugin
export default {"modal-content":"GalleryModal_modal-content__5SWo+","main":"GalleryModal_main__UQWz8","confirm":"GalleryModal_confirm__JIopJ","buttons":"GalleryModal_buttons__XVhFr"};